import { Box, Link, makeStyles, Typography } from "@material-ui/core";

import { theme } from "theme";

const useStyles = makeStyles({
  link: {
    fontWeight: "normal",
    fontSize: "1rem",
    fontStyle: "italic",
    color: theme.custom.palette.blue.main,
    "&:hover": {
      color: theme.custom.palette.blue.main,
    },
  },
});

const RecaptchaTermsNotice = () => {
  const classes = useStyles();

  return (
    // https://developers.google.com/recaptcha/docs/faq#id-like-to-hide-the-recaptcha-badge.-what-is-allowed
    <Box fontStyle="italic">
      <Typography color="textSecondary" component="div">
        This site is protected by reCAPTCHA and the Google{" "}
        <Link
          className={classes.link}
          href="https://policies.google.com/privacy"
          target="_blank"
        >
          Privacy Policy
        </Link>
        {" and "}
        <Link
          className={classes.link}
          href="https://policies.google.com/terms"
          target="_blank"
        >
          Terms of Service
        </Link>
        {" apply."}
      </Typography>
    </Box>
  );
};

export default RecaptchaTermsNotice;
